<template>
  <div>
    <ul v-if="messages && messages.length>0" class="w-full mx-auto">
      <li v-for="sender in senders" :key="sender">
        <ul class="flex-1 divide-y divide-indigo-100 overflow-y-auto">
          <li v-for="message in messagesByUser(sender)" :key="message.id"
            class="p-4 text-sm flex flex-col
               text-left"
            :class="bgMessage(message.read)">
            <div class="flex flex-col">
              <div class="pr-4 text-xs text-gray-600 font-bold">
                {{ message.from_user.name }}
              </div>
              <div class="text-xs">
                [ {{ message.subject }} ]
              </div>

            </div>
            <div class="text-sm text-black">
              {{ message.body }}
            </div>
            <div class="flex justify-end text-md pt-4">
              <button class="p-2 uppercase mr-4 px-4"
                :class="buttonClass(message.read)" @click="answer(message)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M8.31 189.9l176-151.1c15.41-13.3 39.69-2.509 39.69 18.16v80.05C384.6 137.9 512 170.1 512 322.3c0 61.44-39.59 122.3-83.34 154.1c-13.66 9.938-33.09-2.531-28.06-18.62c45.34-145-21.5-183.5-176.6-185.8v87.92c0 20.7-24.31 31.45-39.69 18.16l-176-151.1C-2.753 216.6-2.784 199.4 8.31 189.9z"/></svg>
              </button>
              <button class="p-2 uppercase px-4"
                v-if="message.read === 0" @click="readMessage(message.id)"
                :class="buttonClass(message.read)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M464 64C490.5 64 512 85.49 512 112C512 127.1 504.9 141.3 492.8 150.4L275.2 313.6C263.8 322.1 248.2 322.1 236.8 313.6L19.2 150.4C7.113 141.3 0 127.1 0 112C0 85.49 21.49 64 48 64H464zM217.6 339.2C240.4 356.3 271.6 356.3 294.4 339.2L512 176V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V176L217.6 339.2z"/></svg>
              </button>
              <button class="p-2 uppercase px-4"
                v-else @click="unreadMessage(message.id)" :class="buttonClass(message.read)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 417.1c-16.38 0-32.88-4.1-46.88-15.12L0 250.9v213.1C0 490.5 21.5 512 48 512h416c26.5 0 48-21.5 48-47.1V250.9l-209.1 151.1C288.9 412 272.4 417.1 256 417.1zM493.6 163C484.8 156 476.4 149.5 464 140.1v-44.12c0-26.5-21.5-48-48-48l-77.5 .0016c-3.125-2.25-5.875-4.25-9.125-6.5C312.6 29.13 279.3-.3732 256 .0018C232.8-.3732 199.4 29.13 182.6 41.5c-3.25 2.25-6 4.25-9.125 6.5L96 48c-26.5 0-48 21.5-48 48v44.12C35.63 149.5 27.25 156 18.38 163C6.75 172 0 186 0 200.8v10.62l96 69.37V96h320v184.7l96-69.37V200.8C512 186 505.3 172 493.6 163zM176 255.1h160c8.836 0 16-7.164 16-15.1c0-8.838-7.164-16-16-16h-160c-8.836 0-16 7.162-16 16C160 248.8 167.2 255.1 176 255.1zM176 191.1h160c8.836 0 16-7.164 16-16c0-8.838-7.164-15.1-16-15.1h-160c-8.836 0-16 7.162-16 15.1C160 184.8 167.2 191.1 176 191.1z"/></svg>
              </button>
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <h5 v-else class="flex justify-center font-sans-serif text-sm mt-10 text-gray-500">
      {{$t('messages.none-received')}}
    </h5>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import MessageForm from '@/components/modals/MessageForm.vue';
import store from '../store';

export default {
  data() {
    return {
      senders: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      messages: 'auth/receivedMessages',
    }),
  },

  created() {
    if (this.messages) this.setSenders();
  },

  beforeUpdate() {
    if (this.messages) this.setSenders();
  },

  methods: {
    setSenders() {
      this.senders = [];
      this.messages.forEach((message) => {
        if (!this.senders.includes(message.from_user_id)) this.senders.push(message.from_user_id);
      });
    },

    messagesByUser(id) {
      if (this.messages) { return this.messages.filter((message) => message.from_user_id === id); }
      return '';
    },

    bgMessage(read) {
      if (read === 0) return 'bg-white font-bold';
      return 'bg-white';
    },

    buttonClass(read) {
      if (read === 0) return 'text-beige-academy-300';
      return 'text-black hover:bg-white hover:text-beige-academy-300';
    },

    readMessage(id) {
      axios.put(`/api/messages/${id}/read`).then(() => {
        store.dispatch('auth/getReceivedMessages');
      }).catch((errors) => {
        console.log(errors);
      });
    },
    unreadMessage(id) {
      axios.put(`/api/messages/${id}/unread`).then(() => {
        store.dispatch('auth/getReceivedMessages');
      }).catch((errors) => {
        console.log(errors);
      });
    },

    answer(message) {
      this.readMessage(message.id);
      this.$modal.show(
        MessageForm, { fromUser: this.user, toUser: message.from_user, subj: message.subject },
        { adaptive: true, draggable: true },
      );
    },
  },

};
</script>
